import firebase from 'firebase'
import { getSpyders, getSpyderAnalytics } from '@/db/SpyderDB'
import ForeplayAPI from '@/api/foreplayServer'

export default {
  namespaced: true,
  state: {
    spyderSubscriptions: [],
    spyderSubscriptionsLoading: true,
    brandAnalytics: [],
    brandAnalyticsLoading: false
  },
  getters: {
    // Get Spyder Subscriptions
    getSpyderSubscriptions: state => state.spyderSubscriptions,
    getSpyderSubscriptionsLoading: state => state.spyderSubscriptionsLoading,
    getBrandAnalytics: state => state.brandAnalytics,
    getBrandAnalyticsLoading: state => state.brandAnalyticsLoading
  },
  mutations: {
    // Set Spyder Subscriptions
    SET_SPYDER_SUBSCRIPTIONS (state, subscriptions) {
      state.spyderSubscriptions = subscriptions
    },
    SET_SPYDER_SUBSCRIPTIONS_LOADING (state, loading) {
      state.spyderSubscriptionsLoading = loading
    },
    SET_BRAND_ANALYTICS (state, analytics) {
      state.brandAnalytics = analytics
    },
    SET_BRAND_ANALYTICS_LOADING (state, loading) {
      state.brandAnalyticsLoading = loading
    }
  },
  actions: {
    async fetchSpyderLimit ({ rootState }) {
      const limitOwner = rootState.AuthModule?.team?.created_by || rootState.AuthModule.user?.user_id

      const db = firebase.firestore()
      const snapshot = await db.collection('auth-users').doc(limitOwner).get()

      return snapshot.data().spyderLimit || 2
    },
    // Fetch Spyder Subscriptions
    async fetchSpyderSubscriptions ({ commit, rootState }) {

      const fetchSubscriptions = async () => {
        const db = firebase.firestore()
        const subscriptionId = rootState.AuthModule?.team?.id || rootState.AuthModule.user?.user_id

        const snapshot = await db.collection('fb_ads_page_track')
          .where('subscribers', 'array-contains', subscriptionId)
          .get()
        const subscriptions = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))

        const scrapedSubscriptions = await Promise.all(subscriptions.map(async (subscription) => {
          if (subscription?.brandId) {
            const snapshot = await db.collection('brands').doc(subscription.brandId).get()
            return { id: snapshot.id, ...snapshot.data(), subscription }
          }
          return { subscription }

        }))

        return scrapedSubscriptions
      }

      const result = await getSpyders(fetchSubscriptions)
      console.log('INDEX DB RESULTS', result)

      // Set initial cached data
      commit('SET_SPYDER_SUBSCRIPTIONS', result.cached)
      commit('SET_SPYDER_SUBSCRIPTIONS_LOADING', false)

      // Update with fresh data when it arrives
      const freshData = result.fresh.then(data => {
        commit('SET_SPYDER_SUBSCRIPTIONS', data)
      })

      return {
        cached: result.cached,
        fresh: freshData
      }
    },
    async fetchBrandAnalytics ({ commit }) {
      const getBrandAnalytics = async () => {
        const analytics = await ForeplayAPI.Brands.getBrandBulkAnalytics()
        return analytics
      }

      try {
        commit('SET_BRAND_ANALYTICS_LOADING', true)
        const result = await getSpyderAnalytics(getBrandAnalytics)
        console.log('INDEX DB RESULTS', result)

        // Set initial cached data
        commit('SET_BRAND_ANALYTICS', result.cached)
        commit('SET_BRAND_ANALYTICS_LOADING', false)

        const freshData = result.fresh.then(data => {
          commit('SET_BRAND_ANALYTICS', data)
        })

        return {
          cached: result.cached,
          fresh: freshData
        }
      } catch (error) {
        console.error('Error fetching brand analytics:', error)
        commit('SET_BRAND_ANALYTICS', [])
        commit('SET_BRAND_ANALYTICS_LOADING', false)
      }
    }
  }
}
